module.exports = __webpack_public_path__ + "static/media/leafa-icon.bd09db23.png";